<template>
    <div id="SectionMain" class="section-main wsl-flex-center-ng">
        <ul class="scrollspy">
            <router-link to="#SectionMain" tag="li" class="top" active-class="active_" :class="{active: smain}">
                <a v-scroll-to="'#SectionMain'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <img class="icon icon-inactive" src="../assets/img/scrollspy-top.png" alt="">
                    <img class="icon icon-active" src="../assets/img/scrollspy-top-active.png" alt="">
                </a>
            </router-link>
            <router-link to="#Section-01" tag="li" class="inner" active-class="active_" :class="{active: s1}">
                <a v-scroll-to="'#Section-01'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>01</span>
                </a>
            </router-link>
            <router-link to="#Section-02" tag="li" class="inner" active-class="active_" :class="{active: s2}">
                <a v-scroll-to="'#Section-02'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>02</span>
                </a>
            </router-link>
            <router-link to="#Section-03" tag="li" class="inner" active-class="active_" :class="{active: s3}">
                <a v-scroll-to="'#Section-03'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>03</span>
                </a>
            </router-link>
            <router-link to="#Section-04" tag="li" class="inner" active-class="active_" :class="{active: s4}">
                <a v-scroll-to="'#Section-04'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>04</span>
                </a>
            </router-link>
            <router-link to="#Section-05" tag="li" class="inner" active-class="active_" :class="{active: s5}">
                <a v-scroll-to="'#Section-05'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>05</span>
                </a>
            </router-link>
            <router-link to="#Section-06" tag="li" class="inner" active-class="active_" :class="{active: s6}">
                <a v-scroll-to="'#Section-06'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>06</span>
                </a>
            </router-link>
            <router-link to="#Section-07" tag="li" class="inner" active-class="active_" :class="{active: s7}">
                <a v-scroll-to="'#Section-07'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <span>07</span>
                </a>
            </router-link>
            <router-link to="#Section-08" tag="li" class="bottom" active-class="active_" :class="{active: s8}">
                <a v-scroll-to="'#Section-08'">
                    <img class="bg" src="../assets/img/scrollspy-active.png" alt="">
                    <img class="icon icon-inactive" src="../assets/img/scrollspy-bottom.png" alt="">
                    <img class="icon icon-active" src="../assets/img/scrollspy-bottom-active.png" alt="">
                </a>
            </router-link>
        </ul>

        <div class="container">
            <div class="wsl-w-100 wsl-h-100 wsl-relative">
                <img alt="" class="wsl-w-100 wsl-h-100"
                     src="../assets/img/teaser.jpg">
                <div class="wsl-abs wsl-abs-bottom wsl-abs-left wsl-m-b-50 m-l-side wsl-hide-sm wsl-hide-xs">
                    <a class="cb-btn" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                </div>
                <div class="wsl-abs wsl-abs-bottom wsl-abs-left wsl-m-b-30 m-l-side wsl-show-sm">
                    <a class="cb-btn" href="//centerbooking.org/registration" target="_blank">Регистрация</a>
                </div>

                <div class="wsl-abs wsl-abs-bottom wsl-abs-right wsl-hide-xs">
                    <div class="wsl-w-100 wsl-h-100 wsl-relative">
                        <img class="wsl-abs wsl-abs-bottom wsl-abs-right" src="../assets/img/sidemenu.png" alt="">
                        <div class="Oswald-DemiBold t16 cb-blue wsl-abs wsl-abs-bottom"
                             style="transform: rotate(-90deg); transform-origin: left top 0; right: -90px;">
                            CENTERBOOKING.RU
                        </div>
                        <ul class="sidemenu Oswald-Regular wsl-text-right">
                            <router-link to="#Section-03" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-03'">
                                    ТУРЫ
                                </a>
                            </router-link>
                            <router-link to="#Section-04" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-04'">
                                    ОТЕЛИ
                                </a>
                            </router-link>
                            <router-link to="#Section-05" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-05'">
                                    БИЛЕТЫ
                                </a>
                            </router-link>
                            <router-link to="#Section-06" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-06'">
                                    СТРАХОВАНИЕ
                                </a>
                            </router-link>
                            <router-link to="#Section-01" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-01'">
                                    НАДЕЖНОСТЬ
                                </a>
                            </router-link>
                            <router-link to="#Section-01" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-01'">
                                    ВЫГОДА
                                </a>
                            </router-link>
                            <router-link to="#Section-01" tag="li" active-class="active">
                                <a v-scroll-to="'#Section-01'">
                                    УДОБСТВО
                                </a>
                            </router-link>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SectionMain',
  data () {
    return {
      scrollTop: 0,
      smain: false,
      s1: false,
      s2: false,
      s3: false,
      s4: false,
      s5: false,
      s6: false,
      s7: false,
      s8: false
    }
  },
  methods: {
    handleScroll: _.debounce(function () {
      this.scrollTop = window.scrollY // > 0
      const nav = document.getElementsByTagName('nav')[0].clientHeight + 10
      const s1 = document.getElementById('Section-01').offsetTop - nav - 300
      const s2 = document.getElementById('Section-02').offsetTop - nav - 300
      const s3 = document.getElementById('Section-03').offsetTop - nav - 300
      const s4 = document.getElementById('Section-04').offsetTop - nav - 300
      const s5 = document.getElementById('Section-05').offsetTop - nav - 300
      const s6 = document.getElementById('Section-06').offsetTop - nav - 300
      const s7 = document.getElementById('Section-07').offsetTop - nav - 300
      const s8 = document.getElementById('Section-08').offsetTop - nav - 500
      this.smain = false
      this.s1 = false
      this.s2 = false
      this.s3 = false
      this.s4 = false
      this.s5 = false
      this.s6 = false
      this.s7 = false
      this.s8 = false
      if (this.scrollTop < s1) {
        this.smain = true
      } else if (this.scrollTop >= s1 && this.scrollTop < s2) {
        this.s1 = true
      } else if (this.scrollTop >= s2 && this.scrollTop < s3) {
        this.s2 = true
      } else if (this.scrollTop >= s3 && this.scrollTop < s4) {
        this.s3 = true
      } else if (this.scrollTop >= s4 && this.scrollTop < s5) {
        this.s4 = true
      } else if (this.scrollTop >= s5 && this.scrollTop < s6) {
        this.s5 = true
      } else if (this.scrollTop >= s6 && this.scrollTop < s7) {
        this.s6 = true
      } else if (this.scrollTop >= s7 && this.scrollTop < s8) {
        this.s7 = true
      } else if (this.scrollTop >= s8) {
        this.s8 = true
      }
    }, 30)
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>

</style>
